<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="gdprDialog"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLongTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            Zpracování osobních údajů
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body legal">
          <h5 class="section">Podmínky ochrany osobních údajů</h5>
          <ol>
            <li>
              Společnost Pivo&amp;Co s.r.o., IČ: 09246746, se sídlem:
              Litoměřická 405/9, Prosek, 190 00 Praha 9 je podle čl. 4 bod 7
              nařízení Evropského parlamentu a Rady (EU) 2016/679 o ochraně
              fyzických osob v souvislosti se zpracováním osobních údajů a o
              volném pohybu těchto údajů (dále jen jako „GDPR”) správcem Vašich
              osobních údajů, které pro dále uvedené účely shromažďuje,
              disponuje s nimi a nese odpovědnost za jejich zákonné zpracování.
            </li>
            <li>
              Osobními údaji se podle GDPR rozumí veškeré informace o
              identifikované nebo identifikovatelné fyzické osobě;
              identifikovatelnou fyzickou osobou je fyzická osoba, kterou lze
              přímo či nepřímo identifikovat, zejména odkazem na určitý
              identifikátor, například jméno, identifikační číslo, lokační
              údaje, síťový identifikátor nebo na jeden či více zvláštních prvků
              fyzické, fyziologické, genetické, psychické, ekonomické, kulturní
              nebo společenské identity této fyzické osoby.
            </li>
            <li>
              Zpracovávány jsou Vaše následující osobní údaje:
              <ul>
                <li>jméno a příjmení</li>
                <li>e-mailová adresa</li>
                <li>telefonní číslo</li>
                <li>adresa bydliště</li>
              </ul>
              (dále jen jako „osobní údaje“).
            </li>
            <li>
              Spr&aacute;vce nem&aacute; osobu tzv. pověřence. Spr&aacute;vce
              lze kontaktovat na emailov&eacute; adrese
              simon.klima@hoppyhedgehog.cz.
            </li>
            <li>
              V&yacute;&scaron;e uveden&eacute; osobn&iacute; &uacute;daje
              spr&aacute;vce zpracov&aacute;v&aacute;
              <strong>z těchto z&aacute;konn&yacute;ch důvodů</strong>:
              <ul>
                <li>
                  odbaven&iacute; objedn&aacute;vky a dal&scaron;&iacute;ho
                  plněn&iacute; z kupn&iacute; smlouvy, pokud dojde k
                  jej&iacute;mu uzavřen&iacute; [čl. 6 odst. 1 p&iacute;sm. b)
                  GDPR]
                </li>
                <li>
                  opr&aacute;vněn&yacute; z&aacute;jem spr&aacute;vce na
                  poskytov&aacute;n&iacute; př&iacute;m&eacute;ho marketingu -
                  zejm&eacute;na zas&iacute;l&aacute;n&iacute; obchodn&iacute;ch
                  sdělen&iacute; a newsletterů [čl. 6 odst. 1 p&iacute;sm. f)
                  GDPR],
                </li>
                <li>
                  V&aacute;&scaron; souhlas se zpracov&aacute;n&iacute;m pro
                  &uacute;čely poskytov&aacute;n&iacute; př&iacute;m&eacute;ho
                  marketingu - zejm&eacute;na zas&iacute;l&aacute;n&iacute;
                  obchodn&iacute;ch sdělen&iacute; a newsletterů [čl. 6 odst. 1
                  p&iacute;sm. a) GDPR ve spojen&iacute; s &sect; 7 odst. 2
                  z&aacute;kona č. 480/2004 Sb., o někter&yacute;ch
                  služb&aacute;ch informačn&iacute; společnosti], a to
                  v&nbsp;př&iacute;padě, že nedo&scaron;lo k objedn&aacute;vce
                  zbož&iacute; nebo služby.
                </li>
              </ul>
            </li>
            <li>
              <strong
                >&Uacute;čelem vyžadov&aacute;n&iacute; osobn&iacute;ch
                &uacute;dajů ze strany spr&aacute;vce a jejich
                n&aacute;sledn&eacute; zpracov&aacute;n&iacute;</strong
              >
              je &uacute;spě&scaron;n&eacute; vyř&iacute;zen&iacute;
              objedn&aacute;vky a v&yacute;kon pr&aacute;v a povinnost&iacute;
              vypl&yacute;vaj&iacute;c&iacute; ze smluvn&iacute;ho vztahu mezi
              spr&aacute;vcem a V&aacute;mi (jm&eacute;no,
              př&iacute;jmen&iacute; a adresa pro uzavřen&iacute; kupn&iacute;
              smlouvy, doručen&iacute; zbož&iacute; a&nbsp;vystaven&iacute;
              &uacute;četn&iacute;ho dokladu). Telefonn&iacute; č&iacute;slo a
              e-mailov&aacute; adresa jsou poskytov&aacute;ny za &uacute;čelem
              zkontaktov&aacute;n&iacute; a informov&aacute;n&iacute; V&aacute;s
              o stavu a realizaci objedn&aacute;vky. Dal&scaron;&iacute;m
              &uacute;čelem zpracov&aacute;v&aacute;n&iacute; těchto
              osobn&iacute;ch &uacute;dajů zas&iacute;l&aacute;n&iacute;
              obchodn&iacute;ch sdělen&iacute; a dal&scaron;&iacute;ch
              marketingov&yacute;ch aktivit.
            </li>
            <li>
              Ve vztahu k Osobn&iacute;m &uacute;dajům nebude ze strany
              spr&aacute;vce doch&aacute;zet k automatick&eacute;mu
              individu&aacute;ln&iacute;mu rozhodov&aacute;n&iacute; včetně
              profilov&aacute;n&iacute; ve smyslu čl. 22 GDPR.
            </li>
            <li>
              Spr&aacute;vce zpracov&aacute;v&aacute; osobn&iacute; &uacute;daje
              rovněž za &uacute;čelem evidence kupn&iacute; smlouvy a
              př&iacute;padn&eacute;ho budouc&iacute;ho uplatněn&iacute; a
              obranu pr&aacute;v, opr&aacute;vněn&yacute;ch z&aacute;jmů a
              povinnost&iacute; smluvn&iacute;ch stran. V t&eacute;to
              souvislosti spr&aacute;vce osobn&iacute; &uacute;daje
              uchov&aacute;v&aacute; po dobu nezbytnou (10 let od
              ukončen&iacute; posledn&iacute;ho plněn&iacute; dle kupn&iacute;
              smlouvy, nepožaduje-li jin&yacute; pr&aacute;vn&iacute; předpis
              uchov&aacute;n&iacute; smluvn&iacute; dokumentace po dobu
              del&scaron;&iacute;. Spr&aacute;vce uchov&aacute;v&aacute;
              osobn&iacute; &uacute;daje rovněž po dobu, než je odvol&aacute;n
              souhlas se zpracov&aacute;n&iacute;m osobn&iacute;ch &uacute;dajů
              pro &uacute;čely marketingu (nejd&eacute;le 2 roky). Při
              odvol&aacute;n&iacute; souhlasu se spr&aacute;vce zavazuje
              osobn&iacute; kontakty vymazat. Spr&aacute;vce osobn&iacute;
              &uacute;daje rovněž vymaže po uplynut&iacute; doby
              uchov&aacute;v&aacute;n&iacute; osobn&iacute;ch &uacute;dajů.
            </li>
            <li>
              Př&iacute;jemci osobn&iacute;ch &uacute;dajů jsou osoby
              pod&iacute;lej&iacute;c&iacute; se na dod&aacute;n&iacute;
              zbož&iacute; a realizaci platby na z&aacute;kladě kupn&iacute;
              smlouvy, osoby zaji&scaron;ťuj&iacute;c&iacute; doručen&iacute;
              zakoupen&eacute;ho zbož&iacute; z&aacute;silkov&yacute;m způsobem
              a&nbsp;př&iacute;padně osoby pověřen&eacute; spr&aacute;vcem
              vym&aacute;h&aacute;n&iacute;m pohled&aacute;vek
              pr&aacute;vn&iacute; cestou za &uacute;čelem ochrany pr&aacute;v a
              opr&aacute;vněn&yacute;ch z&aacute;jmů spr&aacute;vce.
              <strong
                >Osobn&iacute; &uacute;daje nebudou před&aacute;ny do
                třet&iacute;ch zem&iacute; (země mimo EU) ani
                mezin&aacute;rodn&iacute; organizaci.</strong
              >
            </li>
            <li>
              <strong
                >Vezměte, pros&iacute;me, na vědom&iacute;, že podle GDPR
                m&aacute;te pr&aacute;vo:</strong
              >
              <ul>
                <li>
                  požadovat po n&aacute;s informaci, zda Va&scaron;e
                  osobn&iacute; &uacute;daje zpracov&aacute;v&aacute;me, a v
                  př&iacute;padě zpracov&aacute;v&aacute;n&iacute; pak
                </li>
                <li>
                  vyž&aacute;dat si u n&aacute;s př&iacute;stup k těmto
                  &uacute;dajům a tyto nechat aktualizovat nebo opravit,
                  popř&iacute;padě požadovat omezen&iacute; jejich
                  zpracov&aacute;n&iacute;,
                </li>
                <li>
                  požadovat po n&aacute;s v&yacute;maz těchto osobn&iacute;ch
                  &uacute;dajů, v&yacute;maz provedeme, pokud to nebude
                  v&nbsp;rozporu s&nbsp;platn&yacute;mi pr&aacute;vn&iacute;mi
                  předpisy nebo opr&aacute;vněn&yacute;mi z&aacute;jmy
                  spr&aacute;vce,
                </li>
                <li>
                  vzn&eacute;st n&aacute;mitku proti zpracov&aacute;n&iacute; na
                  z&aacute;kladě opr&aacute;vněn&eacute;ho z&aacute;jmu
                  spr&aacute;vce,
                </li>
                <li>
                  na přenositelnost &uacute;dajů, pokud se jedn&aacute; o
                  automatizovan&eacute; zpracov&aacute;n&iacute; na
                  z&aacute;kladě souhlasu nebo z&nbsp;důvodu plněn&iacute;
                  smlouvy,
                </li>
                <li>
                  požadovat kopii zpracov&aacute;van&yacute;ch osobn&iacute;ch
                  &uacute;dajů,
                </li>
                <li>
                  zru&scaron;it kdykoliv zas&iacute;l&aacute;n&iacute;
                  obchodn&iacute;ch sdělen&iacute;,
                </li>
                <li>
                  na &uacute;činnou soudn&iacute; ochranu, pokud m&aacute;te za
                  to, že va&scaron;e pr&aacute;va podle GDPR byla
                  poru&scaron;ena v&nbsp;důsledku zpracov&aacute;n&iacute;
                  va&scaron;ich osobn&iacute;ch &uacute;dajů v rozporu s
                  t&iacute;mto GDPR,
                </li>
                <li>
                  podat st&iacute;žnost u &Uacute;řadu pro ochranu
                  osobn&iacute;ch &uacute;dajů.
                </li>
              </ul>
            </li>
            <li>
              Spr&aacute;vce prohla&scaron;uje, že přijal ve&scaron;ker&aacute;
              vhodn&aacute; technick&aacute; a organizačn&iacute;
              opatřen&iacute; k zabezpečen&iacute; osobn&iacute;ch &uacute;dajů.
              Spr&aacute;vce d&aacute;le přijal technick&aacute; opatřen&iacute;
              k zabezpečen&iacute; datov&yacute;ch &uacute;loži&scaron;ť a
              &uacute;loži&scaron;ť osobn&iacute;ch &uacute;dajů v
              listinn&eacute; podobě. Spr&aacute;vce d&aacute;le
              prohla&scaron;uje, že k osobn&iacute;m &uacute;dajům maj&iacute;
              př&iacute;stup pouze j&iacute;m pověřen&eacute; osoby.
            </li>
            <li>
              Spr&aacute;vce je opr&aacute;vněn tyto podm&iacute;nky změnit.
              Novou verzi podm&iacute;nek ochrany osobn&iacute;ch &uacute;dajů
              zveřejn&iacute; na sv&yacute;ch internetov&yacute;ch
              str&aacute;nk&aacute;ch a z&aacute;roveň V&aacute;m za&scaron;le
              novou verzi těchto podm&iacute;nek Va&scaron;i e-mailovou adresu,
              kterou jste spr&aacute;vci poskytli.
            </li>
          </ol>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            Tyto podm&iacute;nky nab&yacute;vaj&iacute; &uacute;činnosti dnem 9. 11. 2020
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Gdpr",
};
</script>